import { AdminNotification } from "../types/notification.definition";
import {
  deleteNotification,
  getNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from "../webclients/notification.client";

export const notificationApi = {
  getNotifications: async (): Promise<AdminNotification[]> => {
    const response = await getNotifications();
    return response.data;
  },

  markAsRead: async (id: number): Promise<AdminNotification> => {
    const response = await markNotificationAsRead(id);
    return response.data;
  },

  markAllAsRead: async (): Promise<void> => {
    await markAllNotificationsAsRead();
  },

  deleteNotification: async (id: number): Promise<void> => {
    await deleteNotification(id);
  },
};

export default notificationApi;
